import React, { Component } from 'react';
import $ from "jquery";
class OurTeamInfo extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }

  toggle_info(id){
    if($("#"+id).hasClass("hide")){
      $("#"+id+"_i").text("Read Less...");
    }else {
      $("#"+id+"_i").text("Read More...")
    }
    $('#'+id).toggleClass('hide');
  }



  render() {
    return (

       <div class="container-xxl py-5 inner_con_grey" id="leader">

             <div class="container inner_con mb-5" id="consultants">
                 <h1 class="text-start mb-2 wow fadeInUp" data-wow-delay="0.1s">CA/CS</h1>
                 <section className="team-section">

                 <div className="team-card">
                   <div className="team-image">
                     <img src="/assets/img/profile/vipul_jain.png" alt="Vipul Jain"/>
                   </div>
                   <div className="team-content">
                     <h3>Vipul Jain</h3>
                     <div className="team-role team_role_mb">Practicing Chartered Accountant</div>
                     <p><i>[Chartered Accountant]</i></p>
                     <p>
                     Vipul Jain is the Founder and Partner of Vipul N Jain & Associates, a firm of
                     Chartered Accountants engaged in audit, taxation and accounting-related
                     professional services, and is associated with BYLAWS Legal LLP in a professional
                     support capacity for financial, accounting and other related matters. An Associate
                     Member of the Institute of Chartered Accountants of India (ICAI), he brings over 16
                     years of experience across assurance, taxation and compliance-oriented advisory
                     assignments, supporting corporates, public trusts, NGOs and financial institutions.
                     </p>

                     <div className="hide" id="vipul_jain">
                     <p>
                     In coordination with BYLAWS Legal LLP, Vipul provides structured financial insight in
                     matters requiring audit interface, financial due diligence, accounting review, GST
                     advisory, company law compliance and regulatory reporting alignment. His
                     professional work includes statutory audits, internal and management audits,
                     systems consultancy, incorporation support, and structured interaction with statutory
                     authorities such as the Registrar of Companies and the Reserve Bank of India,
                     particularly in cross-border structuring and overseas client matters. His experience
                     further extends to participation in bank audits, including statutory, concurrent and
                     revenue audits, strengthening institutional review processes where financial scrutiny
                     intersects with legal structuring.
                     </p>

                     <p>
                     His engagement with BYLAWS Legal LLP enhances the firm’s multidisciplinary
                     capability by integrating financial compliance discipline with legal advisory
                     frameworks, ensuring that client matters involving regulatory filings, financial
                     governance and statutory reporting are addressed with technical precision and
                     professional rigor. His professional focus remains confined to accounting, audit,
                     taxation and allied services, delivered within the scope of chartered accountancy
                     standards.
                     </p>

                     <p>
                     <b>Disclaimer: </b>
                     Vipul Jain is a Chartered Accountant. His role and professional profile
                     relate exclusively to accounting, audit, taxation and allied advisory services. He does
                     not render legal advice. All legal services of BYLAWS Legal LLP are provided solely
                     by advocates enrolled with the Bar Council of India.
                     </p>

                     </div>
                     <p className="read_on" onClick={this.toggle_info.bind(this,'vipul_jain')}><i id="vipul_jain_i">Read More...</i></p>
                   </div>
                 </div>

                 <div className="team-card reverse">
                   <div className="team-image">
                     <img src="/assets/img/profile/princi_agarwal.png" alt="Princi Agarwal"/>
                   </div>
                   <div className="team-content">
                     <h3>Princi Agarwal</h3>
                     <div className="team-role team_role_mb">Practicing Company Secretary</div>
                     <p><i>[Company Secretary]</i></p>
                     <p>
                     Princi Agarwal is a Practicing Company Secretary and the Founder of Princi & Associates, specialising in corporate law advisory, secretarial compliance and regulatory structuring. She is empanelled with BYLAWS Legal LLP, supporting company law and compliance mandates across diverse client engagements for all secretarial practices.
                     </p>

                     <div className="hide" id="princi_agarwal">
                     <p>
                     With over five years of experience, she holds expertise in advising startups, private companies and promoters on company incorporation, corporate structuring, board and shareholder documentation and MCA compliance. Her practice also covers secretarial audits, internal and regulatory audits, corporate due diligence and FEMA compliances.
                     </p>

                     <p>
                     She has also gained exposure at Times/ Internet/ ETMONEY, contributing to compliance and governance functions within a regulated fintech environment, providing her with practical insight into high-growth, compliance-driven business models.
                     </p>
                     <p>
                     At BYLAWS, she brings a structured, governance-focused approach, ensuring regulatory alignment, company related matters and robust compliance frameworks for clients.
                     </p>
                     </div>
                     <p className="read_on" onClick={this.toggle_info.bind(this,'princi_agarwal')}><i id="princi_agarwal_i">Read More...</i></p>
                   </div>
                 </div>

               </section>
              </div>




        </div>


    );
  }
}

export default OurTeamInfo;
